export const NATWEST_BRAND = 'natwest';

export const NWB_BRAND = 'nwb';

export const RBS_BRAND = 'rbs';

export const NATWEST = 'Natwest';

export const RBS = 'RBS';

export const ANALYTICS_CHECKBOXNAME = 'checkBoxName'

export const ANALYTICS_CHECKBOXOPTION = 'checkBoxOption'

export const ANALYTICS_CHECKBOX = 'CheckBox'

export const ANALYTICS_DATEFIELDOPTION = 'dateFieldOption'

export const ANALYTICS_DATEFIELDTITLE = 'dateFieldTitle'

export const ANALYTICS_DATEFIELD = 'DateField'

export const ANALYTICS_TEXTFIELD = 'TextField'

export const ANALYTICS_TEXTFIELDTITLE = 'textFieldTitle'

export const ANALYTICS_DATE = 'Date'

export const ANALYTICS_TEXTAREA = 'TextArea'

export const LABEL_TYPE = 'label'

export const VALUE_AND_LABEL_TYPE = 'valueAndLabel'

export const ANALYTICS_DIGITAL_DATA = 'digitalData'

export const ANALYTICS_APPLICATION_DATA = 'applicationData'

export const DIGITAL_DATA = 'digitaldata'

export const APPLICATION = 'application'

export const FORM = 'form'

export const FORMFIELD = 'formField'

export const FORMFIELDVALUES = 'formFieldValues'

export const ERRORFORMFIELD = 'errorFormField'

export const ERRORMESSAGE = 'errorMessage'

export const ANALYTICS_DROPDOWNNAME = 'dropdownName'

export const ANALYTICS_DROPDOWNOPTION = 'dropdownOption'

export const ANALYTICS_RADIOBUTTONTITLE = 'radioButtonTitle'

export const ANALYTICS_RADIOBUTTONOPTION = 'radioButtonOption'

export const ANALYTICS_DROPDOWN = 'DropdownSelection'

export const ANALYTICS_RADIOBUTTON = 'RadioButton'

export const ANALYTICS_ERROR = 'Error'

export const ANALYTICS_RADIO_LABEL_AND_VALUE = 'radioLabelAndValue'

export const ANALYTICS_DROPDOWN_LABEL_AND_VALUE = 'dropDownLabelAndValue'

export const ANALYTICS_INPUT_LABEL_AND_VALUE = 'inputLabelAndValue'

export const ANALYTICS_FORM_ERROR = 'formError'

export const ANALYTICS_HINT_TEXT = 'HintText'

export const ANALYTICS_TOOLTIP = 'Tooltip'

export const ANALYTICS_TOOLTIPTITLE = 'toolTipTitle'

export const ANALYTICS_ESIGNTITLE = 'eSignTitle'

export const ANALYTICS_ESIGN = 'eSign'

export const ANALYTICS_SUMMARY = 'summary'

export const REQUIREDERROR = 'RequiredError'

export const ANALYTICS_POSTCODE_LABEL = 'Postcode'

export const ANALYTICS_POSTCODE_TITLE = 'postcodeTitle';

export const THANK_YOU_PAGE_TEXT = 'Thank you page';

export const DEFAULT_BRAND = 'nwb'

export const PAGE_NOT_FOUND__ERROR_TITLE = "Sorry, we couldn't find the page you were looking for";

export const PAGE_NOT_FOUND__ERROR_MESSAGE = 'This page might have moved, had its name changed or be temporarily unavailable.';

export const ANALYTICS_FEEDBACK = 'Feedback';

export const ANALYTICS_FEEDBACKNAME = 'feedbackTitle';

export const ANALYTICS_FEEDBACKOPTION = 'feedbackStarValue';

export const FORM_SUBMIT_ACKNOWLEDGEMENT = 'Application has been submitted';

export const FEEDBACK_SUBMIT_ACKNOWLWDGEMENT = 'Thank you for your feedback!';